import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import Selectsearch from "react-select"
import { Button, Form } from 'reactstrap';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import DatePicker from "react-datepicker"

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

import {  
    allStudents,
    student_all_practiceschedule
} from 'Actions';

import ShowPSElement1 from './editweek1';
import ShowPSElement2 from './editweek2';
import ShowPSElement3 from './editweek3';
import ShowPSElement4 from './editweek4';

import EditPSElement1 from '../../../../golf/practiceschedule/component/editweek1';
import EditPSElement2 from '../../../../golf/practiceschedule/component/editweek2';
import EditPSElement3 from '../../../../golf/practiceschedule/component/editweek3';
import EditPSElement4 from '../../../../golf/practiceschedule/component/editweek4';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';


class practiceschedule extends Component {
   
    constructor(props) {
       
        super(props);
            this.confirmationDialog = React.createRef();
            this.nodeRef = React.createRef();
            this.state = {
                heightProportion: 4000,
                widthProportion: 1200,
                student:this.props.data.student, 
                startdate:'',
                enddate:'',
                viewdiv1:false,
                viewdiv2:true,
                viewdiv3:true,
                element1:true,
                element2:false,
                element3:false,
                element4:false,
                viewelement:1,
                practdata:this.props.data.practdata,
                example1:'1',
                editdiv2:false,
                editdiv3:false,

                //week 1
                practshot_1_1_1:'',
                typeopt_1_1_1:[],
                drillopt_1_1_1:[],
                edpractdrill_1_1_1:'',
                practshot_1_1_2:'',
                typeopt_1_1_2:[],
                drillopt_1_1_2:[],
                edpractdrill_1_1_2:'',
                practshot_1_1_3:'',
                typeopt_1_1_3:[],
                drillopt_1_1_3:[],
                edpractdrill_1_1_3:'',
                practshot_1_1_4:'',
                typeopt_1_1_4:[],
                drillopt_1_1_4:[],
                edpractdrill_1_1_4:'',
                practshot_1_1_5:'',
                typeopt_1_1_5:[],
                drillopt_1_1_5:[],
                edpractdrill_1_1_5:'',
                //tuesday
                practshot_1_2_1:'',
                typeopt_1_2_1:[],
                drillopt_1_2_1:[],
                edpractdrill_1_2_1:'',
                practshot_1_2_2:'',
                typeopt_1_2_2:[],
                drillopt_1_2_2:[],
                edpractdrill_1_2_2:'',
                practshot_1_2_3:'',
                typeopt_1_2_3:[],
                drillopt_1_2_3:[],
                edpractdrill_1_2_3:'',
                practshot_1_2_4:'',
                typeopt_1_2_4:[],
                drillopt_1_2_4:[],
                edpractdrill_1_2_4:'',
                practshot_1_2_5:'',
                typeopt_1_2_5:[],
                drillopt_1_2_5:[],
                edpractdrill_1_2_5:'',
                //Wednesday
                practshot_1_3_1:'',
                typeopt_1_3_1:[],
                drillopt_1_3_1:[],
                edpractdrill_1_3_1:'',
                practshot_1_3_2:'',
                typeopt_1_3_2:[],
                drillopt_1_3_2:[],
                edpractdrill_1_3_2:'',
                practshot_1_3_3:'',
                typeopt_1_3_3:[],
                drillopt_1_3_3:[],
                edpractdrill_1_3_3:'',
                practshot_1_3_4:'',
                typeopt_1_3_4:[],
                drillopt_1_3_4:[],
                edpractdrill_1_3_4:'',
                practshot_1_3_5:'',
                typeopt_1_3_5:[],
                drillopt_1_3_5:[],
                edpractdrill_1_3_5:'',
                //Thursday
                practshot_1_4_1:'',
                typeopt_1_4_1:[],
                drillopt_1_4_1:[],
                edpractdrill_1_4_1:'',
                practshot_1_4_2:'',
                typeopt_1_4_2:[],
                drillopt_1_4_2:[],
                edpractdrill_1_4_2:'',
                practshot_1_4_3:'',
                typeopt_1_4_3:[],
                drillopt_1_4_3:[],
                edpractdrill_1_4_3:'',
                practshot_1_4_4:'',
                typeopt_1_4_4:[],
                drillopt_1_4_4:[],
                edpractdrill_1_4_4:'',
                practshot_1_4_5:'',
                typeopt_1_4_5:[],
                drillopt_1_4_5:[],
                edpractdrill_1_4_5:'',
                //Friday
                practshot_1_5_1:'',
                typeopt_1_5_1:[],
                drillopt_1_5_1:[],
                edpractdrill_1_5_1:'',
                practshot_1_5_2:'',
                typeopt_1_5_2:[],
                drillopt_1_5_2:[],
                edpractdrill_1_5_2:'',
                practshot_1_5_3:'',
                typeopt_1_5_3:[],
                drillopt_1_5_3:[],
                edpractdrill_1_5_3:'',
                practshot_1_5_4:'',
                typeopt_1_5_4:[],
                drillopt_1_5_4:[],
                edpractdrill_1_5_4:'',
                practshot_1_5_5:'',
                typeopt_1_5_5:[],
                drillopt_1_5_5:[],
                edpractdrill_1_5_5:'',
                //Saturday
                practshot_1_6_1:'',
                typeopt_1_6_1:[],
                drillopt_1_6_1:[],
                edpractdrill_1_6_1:'',
                practshot_1_6_2:'',
                typeopt_1_6_2:[],
                drillopt_1_6_2:[],
                edpractdrill_1_6_2:'',
                practshot_1_6_3:'',
                typeopt_1_6_3:[],
                drillopt_1_6_3:[],
                edpractdrill_1_6_3:'',
                practshot_1_6_4:'',
                typeopt_1_6_4:[],
                drillopt_1_6_4:[],
                edpractdrill_1_6_4:'',
                practshot_1_6_5:'',
                typeopt_1_6_5:[],
                drillopt_1_6_5:[],
                edpractdrill_1_6_5:'',
                //Sunday
                practshot_1_7_1:'',
                typeopt_1_7_1:[],
                drillopt_1_7_1:[],
                edpractdrill_1_7_1:'',
                practshot_1_7_2:'',
                typeopt_1_7_2:[],
                drillopt_1_7_2:[],
                edpractdrill_1_7_2:'',
                practshot_1_7_3:'',
                typeopt_1_7_3:[],
                drillopt_1_7_3:[],
                edpractdrill_1_7_3:'',
                practshot_1_7_4:'',
                typeopt_1_7_4:[],
                drillopt_1_7_4:[],
                edpractdrill_1_7_4:'',
                practshot_1_7_5:'',
                typeopt_1_7_5:[],
                drillopt_1_7_5:[],
                edpractdrill_1_7_5:'',

                //Week 2
                practshot_2_1_1:'',
                typeopt_2_1_1:[],
                drillopt_2_1_1:[],
                edpractdrill_2_1_1:'',
                practshot_2_1_2:'',
                typeopt_2_1_2:[],
                drillopt_2_1_2:[],
                edpractdrill_2_1_2:'',
                practshot_2_1_3:'',
                typeopt_2_1_3:[],
                drillopt_2_1_3:[],
                edpractdrill_2_1_3:'',
                practshot_2_1_4:'',
                typeopt_2_1_4:[],
                drillopt_2_1_4:[],
                edpractdrill_2_1_4:'',
                practshot_2_1_5:'',
                typeopt_2_1_5:[],
                drillopt_2_1_5:[],
                edpractdrill_2_1_5:'',
                //tuesday
                practshot_2_2_1:'',
                typeopt_2_2_1:[],
                drillopt_2_2_1:[],
                edpractdrill_2_2_1:'',
                practshot_2_2_2:'',
                typeopt_2_2_2:[],
                drillopt_2_2_2:[],
                edpractdrill_2_2_2:'',
                practshot_2_2_3:'',
                typeopt_2_2_3:[],
                drillopt_2_2_3:[],
                edpractdrill_2_2_3:'',
                practshot_2_2_4:'',
                typeopt_2_2_4:[],
                drillopt_2_2_4:[],
                edpractdrill_2_2_4:'',
                practshot_2_2_5:'',
                typeopt_2_2_5:[],
                drillopt_2_2_5:[],
                edpractdrill_2_2_5:'',
                //Wednesday
                practshot_2_3_1:'',
                typeopt_2_3_1:[],
                drillopt_2_3_1:[],
                edpractdrill_2_3_1:'',
                practshot_2_3_2:'',
                typeopt_2_3_2:[],
                drillopt_2_3_2:[],
                edpractdrill_2_3_2:'',
                practshot_2_3_3:'',
                typeopt_2_3_3:[],
                drillopt_2_3_3:[],
                edpractdrill_2_3_3:'',
                practshot_2_3_4:'',
                typeopt_2_3_4:[],
                drillopt_2_3_4:[],
                edpractdrill_2_3_4:'',
                practshot_2_3_5:'',
                typeopt_2_3_5:[],
                drillopt_2_3_5:[],
                edpractdrill_2_3_5:'',
                //Thursday
                practshot_2_4_1:'',
                typeopt_2_4_1:[],
                drillopt_2_4_1:[],
                edpractdrill_2_4_1:'',
                practshot_2_4_2:'',
                typeopt_2_4_2:[],
                drillopt_2_4_2:[],
                edpractdrill_2_4_2:'',
                practshot_2_4_3:'',
                typeopt_2_4_3:[],
                drillopt_2_4_3:[],
                edpractdrill_2_4_3:'',
                practshot_2_4_4:'',
                typeopt_2_4_4:[],
                drillopt_2_4_4:[],
                edpractdrill_2_4_4:'',
                practshot_2_4_5:'',
                typeopt_2_4_5:[],
                drillopt_2_4_5:[],
                edpractdrill_2_4_5:'',
                //Friday
                practshot_2_5_1:'',
                typeopt_2_5_1:[],
                drillopt_2_5_1:[],
                edpractdrill_2_5_1:'',
                practshot_2_5_2:'',
                typeopt_2_5_2:[],
                drillopt_2_5_2:[],
                edpractdrill_2_5_2:'',
                practshot_2_5_3:'',
                typeopt_2_5_3:[],
                drillopt_2_5_3:[],
                edpractdrill_2_5_3:'',
                practshot_2_5_4:'',
                typeopt_2_5_4:[],
                drillopt_2_5_4:[],
                edpractdrill_2_5_4:'',
                practshot_2_5_5:'',
                typeopt_2_5_5:[],
                drillopt_2_5_5:[],
                edpractdrill_2_5_5:'',
                //Saturday
                practshot_2_6_1:'',
                typeopt_2_6_1:[],
                drillopt_2_6_1:[],
                edpractdrill_2_6_1:'',
                practshot_2_6_2:'',
                typeopt_2_6_2:[],
                drillopt_2_6_2:[],
                edpractdrill_2_6_2:'',
                practshot_2_6_3:'',
                typeopt_2_6_3:[],
                drillopt_2_6_3:[],
                edpractdrill_2_6_3:'',
                practshot_2_6_4:'',
                typeopt_2_6_4:[],
                drillopt_2_6_4:[],
                edpractdrill_2_6_4:'',
                practshot_2_6_5:'',
                typeopt_2_6_5:[],
                drillopt_2_6_5:[],
                edpractdrill_2_6_5:'',
                //Sunday
                practshot_2_7_1:'',
                typeopt_2_7_1:[],
                drillopt_2_7_1:[],
                edpractdrill_2_7_1:'',
                practshot_2_7_2:'',
                typeopt_2_7_2:[],
                drillopt_2_7_2:[],
                edpractdrill_2_7_2:'',
                practshot_2_7_3:'',
                typeopt_2_7_3:[],
                drillopt_2_7_3:[],
                edpractdrill_2_7_3:'',
                practshot_2_7_4:'',
                typeopt_2_7_4:[],
                drillopt_2_7_4:[],
                edpractdrill_2_7_4:'',
                practshot_2_7_5:'',
                typeopt_2_7_5:[],
                drillopt_2_7_5:[],
                edpractdrill_2_7_5:'',

                //Week 3
                practshot_3_1_1:'',
                typeopt_3_1_1:[],
                drillopt_3_1_1:[],
                edpractdrill_3_1_1:'',
                practshot_3_1_2:'',
                typeopt_3_1_2:[],
                drillopt_3_1_2:[],
                edpractdrill_3_1_2:'',
                practshot_3_1_3:'',
                typeopt_3_1_3:[],
                drillopt_3_1_3:[],
                edpractdrill_3_1_3:'',
                practshot_3_1_4:'',
                typeopt_3_1_4:[],
                drillopt_3_1_4:[],
                edpractdrill_3_1_4:'',
                practshot_3_1_5:'',
                typeopt_3_1_5:[],
                drillopt_3_1_5:[],
                edpractdrill_3_1_5:'',
                //tuesday
                practshot_3_2_1:'',
                typeopt_3_2_1:[],
                drillopt_3_2_1:[],
                edpractdrill_3_2_1:'',
                practshot_3_2_2:'',
                typeopt_3_2_2:[],
                drillopt_3_2_2:[],
                edpractdrill_3_2_2:'',
                practshot_3_2_3:'',
                typeopt_3_2_3:[],
                drillopt_3_2_3:[],
                edpractdrill_3_2_3:'',
                practshot_3_2_4:'',
                typeopt_3_2_4:[],
                drillopt_3_2_4:[],
                edpractdrill_3_2_4:'',
                practshot_3_2_5:'',
                typeopt_3_2_5:[],
                drillopt_3_2_5:[],
                edpractdrill_3_2_5:'',
                //Wednesday
                practshot_3_3_1:'',
                typeopt_3_3_1:[],
                drillopt_3_3_1:[],
                edpractdrill_3_3_1:'',
                practshot_3_3_2:'',
                typeopt_3_3_2:[],
                drillopt_3_3_2:[],
                edpractdrill_3_3_2:'',
                practshot_3_3_3:'',
                typeopt_3_3_3:[],
                drillopt_3_3_3:[],
                edpractdrill_3_3_3:'',
                practshot_3_3_4:'',
                typeopt_3_3_4:[],
                drillopt_3_3_4:[],
                edpractdrill_3_3_4:'',
                practshot_3_3_5:'',
                typeopt_3_3_5:[],
                drillopt_3_3_5:[],
                edpractdrill_3_3_5:'',
                //Thursday
                practshot_3_4_1:'',
                typeopt_3_4_1:[],
                drillopt_3_4_1:[],
                edpractdrill_3_4_1:'',
                practshot_3_4_2:'',
                typeopt_3_4_2:[],
                drillopt_3_4_2:[],
                edpractdrill_3_4_2:'',
                practshot_3_4_3:'',
                typeopt_3_4_3:[],
                drillopt_3_4_3:[],
                edpractdrill_3_4_3:'',
                practshot_3_4_4:'',
                typeopt_3_4_4:[],
                drillopt_3_4_4:[],
                edpractdrill_3_4_4:'',
                practshot_3_4_5:'',
                typeopt_3_4_5:[],
                drillopt_3_4_5:[],
                edpractdrill_3_4_5:'',
                //Friday
                practshot_3_5_1:'',
                typeopt_3_5_1:[],
                drillopt_3_5_1:[],
                edpractdrill_3_5_1:'',
                practshot_3_5_2:'',
                typeopt_3_5_2:[],
                drillopt_3_5_2:[],
                edpractdrill_3_5_2:'',
                practshot_3_5_3:'',
                typeopt_3_5_3:[],
                drillopt_3_5_3:[],
                edpractdrill_3_5_3:'',
                practshot_3_5_4:'',
                typeopt_3_5_4:[],
                drillopt_3_5_4:[],
                edpractdrill_3_5_4:'',
                practshot_3_5_5:'',
                typeopt_3_5_5:[],
                drillopt_3_5_5:[],
                edpractdrill_3_5_5:'',
                //Saturday
                practshot_3_6_1:'',
                typeopt_3_6_1:[],
                drillopt_3_6_1:[],
                edpractdrill_3_6_1:'',
                practshot_3_6_2:'',
                typeopt_3_6_2:[],
                drillopt_3_6_2:[],
                edpractdrill_3_6_2:'',
                practshot_3_6_3:'',
                typeopt_3_6_3:[],
                drillopt_3_6_3:[],
                edpractdrill_3_6_3:'',
                practshot_3_6_4:'',
                typeopt_3_6_4:[],
                drillopt_3_6_4:[],
                edpractdrill_3_6_4:'',
                practshot_3_6_5:'',
                typeopt_3_6_5:[],
                drillopt_3_6_5:[],
                edpractdrill_3_6_5:'',
                //Sunday
                practshot_3_7_1:'',
                typeopt_3_7_1:[],
                drillopt_3_7_1:[],
                edpractdrill_3_7_1:'',
                practshot_3_7_2:'',
                typeopt_3_7_2:[],
                drillopt_3_7_2:[],
                edpractdrill_3_7_2:'',
                practshot_3_7_3:'',
                typeopt_3_7_3:[],
                drillopt_3_7_3:[],
                edpractdrill_3_7_3:'',
                practshot_3_7_4:'',
                typeopt_3_7_4:[],
                drillopt_3_7_4:[],
                edpractdrill_3_7_4:'',
                practshot_3_7_5:'',
                typeopt_3_7_5:[],
                drillopt_3_7_5:[],
                edpractdrill_3_7_5:'',

                //Week 4
                practshot_4_1_1:'',
                typeopt_4_1_1:[],
                drillopt_4_1_1:[],
                edpractdrill_4_1_1:'',
                practshot_4_1_2:'',
                typeopt_4_1_2:[],
                drillopt_4_1_2:[],
                edpractdrill_4_1_2:'',
                practshot_4_1_3:'',
                typeopt_4_1_3:[],
                drillopt_4_1_3:[],
                edpractdrill_4_1_3:'',
                practshot_4_1_4:'',
                typeopt_4_1_4:[],
                drillopt_4_1_4:[],
                edpractdrill_4_1_4:'',
                practshot_4_1_5:'',
                typeopt_4_1_5:[],
                drillopt_4_1_5:[],
                edpractdrill_4_1_5:'',
                //tuesday
                practshot_4_2_1:'',
                typeopt_4_2_1:[],
                drillopt_4_2_1:[],
                edpractdrill_4_2_1:'',
                practshot_4_2_2:'',
                typeopt_4_2_2:[],
                drillopt_4_2_2:[],
                edpractdrill_4_2_2:'',
                practshot_4_2_3:'',
                typeopt_4_2_3:[],
                drillopt_4_2_3:[],
                edpractdrill_4_2_3:'',
                practshot_4_2_4:'',
                typeopt_4_2_4:[],
                drillopt_4_2_4:[],
                edpractdrill_4_2_4:'',
                practshot_4_2_5:'',
                typeopt_4_2_5:[],
                drillopt_4_2_5:[],
                edpractdrill_4_2_5:'',
                //Wednesday
                practshot_4_3_1:'',
                typeopt_4_3_1:[],
                drillopt_4_3_1:[],
                edpractdrill_4_3_1:'',
                practshot_4_3_2:'',
                typeopt_4_3_2:[],
                drillopt_4_3_2:[],
                edpractdrill_4_3_2:'',
                practshot_4_3_3:'',
                typeopt_4_3_3:[],
                drillopt_4_3_3:[],
                edpractdrill_4_3_3:'',
                practshot_4_3_4:'',
                typeopt_4_3_4:[],
                drillopt_4_3_4:[],
                edpractdrill_4_3_4:'',
                practshot_4_3_5:'',
                typeopt_4_3_5:[],
                drillopt_4_3_5:[],
                edpractdrill_4_3_5:'',
                //Thursday
                practshot_4_4_1:'',
                typeopt_4_4_1:[],
                drillopt_4_4_1:[],
                edpractdrill_4_4_1:'',
                practshot_4_4_2:'',
                typeopt_4_4_2:[],
                drillopt_4_4_2:[],
                edpractdrill_4_4_2:'',
                practshot_4_4_3:'',
                typeopt_4_4_3:[],
                drillopt_4_4_3:[],
                edpractdrill_4_4_3:'',
                practshot_4_4_4:'',
                typeopt_4_4_4:[],
                drillopt_4_4_4:[],
                edpractdrill_4_4_4:'',
                practshot_4_4_5:'',
                typeopt_4_4_5:[],
                drillopt_4_4_5:[],
                edpractdrill_4_4_5:'',
                //Friday
                practshot_4_5_1:'',
                typeopt_4_5_1:[],
                drillopt_4_5_1:[],
                edpractdrill_4_5_1:'',
                practshot_4_5_2:'',
                typeopt_4_5_2:[],
                drillopt_4_5_2:[],
                edpractdrill_4_5_2:'',
                practshot_4_5_3:'',
                typeopt_4_5_3:[],
                drillopt_4_5_3:[],
                edpractdrill_4_5_3:'',
                practshot_4_5_4:'',
                typeopt_4_5_4:[],
                drillopt_4_5_4:[],
                edpractdrill_4_5_4:'',
                practshot_4_5_5:'',
                typeopt_4_5_5:[],
                drillopt_4_5_5:[],
                edpractdrill_4_5_5:'',
                //Saturday
                practshot_4_6_1:'',
                typeopt_4_6_1:[],
                drillopt_4_6_1:[],
                edpractdrill_4_6_1:'',
                practshot_4_6_2:'',
                typeopt_4_6_2:[],
                drillopt_4_6_2:[],
                edpractdrill_4_6_2:'',
                practshot_4_6_3:'',
                typeopt_4_6_3:[],
                drillopt_4_6_3:[],
                edpractdrill_4_6_3:'',
                practshot_4_6_4:'',
                typeopt_4_6_4:[],
                drillopt_4_6_4:[],
                edpractdrill_4_6_4:'',
                practshot_4_6_5:'',
                typeopt_4_6_5:[],
                drillopt_4_6_5:[],
                edpractdrill_4_6_5:'',
                //Sunday
                practshot_4_7_1:'',
                typeopt_4_7_1:[],
                drillopt_4_7_1:[],
                edpractdrill_4_7_1:'',
                practshot_4_7_2:'',
                typeopt_4_7_2:[],
                drillopt_4_7_2:[],
                edpractdrill_4_7_2:'',
                practshot_4_7_3:'',
                typeopt_4_7_3:[],
                drillopt_4_7_3:[],
                edpractdrill_4_7_3:'',
                practshot_4_7_4:'',
                typeopt_4_7_4:[],
                drillopt_4_7_4:[],
                edpractdrill_4_7_4:'',
                practshot_4_7_5:'',
                typeopt_4_7_5:[],
                drillopt_4_7_5:[],
                edpractdrill_4_7_5:'',
                
            };  

        this.onBackSection = this.onBackSection.bind(this);  
        this.updateDimensions = this.updateDimensions.bind(this);    
        this.backbtnpress = this.backbtnpress.bind(this);    
        this.nextbtnpress = this.nextbtnpress.bind(this); 
        this.editPractice = this.editPractice.bind(this); 
    }

    UNSAFE_componentWillMount() {
		this.props.allStudents();
        
	}

    updateDimensions() {
        if (!this.nodeRef) return;
        const node = this.nodeRef.current;
        const nodewidth = node.offsetWidth;
        const nodeheight = node.offsetHeight;
        this.setState({
          heightProportion: nodeheight,
          widthProportion: nodewidth
        });
    }  

    

    onBackSection(){
        var studentid=this.state.student;
        var startdate="";
        var enddate="";

        this.props.student_all_practiceschedule(studentid, startdate, enddate);
        this.setState({            
                viewdiv2:true,
                 viewdiv3:true,
                 editdiv2:false,
                 editdiv3:false,
        }); 
    }
    

    backbtnpress(evt){
       var curview=this.state.viewelement;
       var preview=curview-1;

       if(preview!=0){
            var nextview='element'+preview;
            var closeview='element'+curview;
            this.setState({ 
                [closeview]:false,
                [nextview]:true,
                viewelement:preview,
            }); 
       }
    }

    nextbtnpress(evt){
        var curview=this.state.viewelement;
        var preview=curview+1;
        if(preview!=5){
             var nextview='element'+preview;
             var closeview='element'+curview;
             this.setState({ 
                 [closeview]:false,
                 [nextview]:true,
                 viewelement:preview,
             }); 
        }
    }

    selectstart = (date) => {  
        this.setState({ startdate:date });           
    }

    selectend = (date) => {  
        this.setState({ enddate:date });           
    }

    

    handleChange = (key, value) => {
        
        if(value==1){
            this.setState({
                element1:true,
                element2:false,
                element3:false,
                element4:false,
            });
        }else if(value==2){
            this.setState({
                element1:false,
                element2:true,
                element3:false,
                element4:false,
            });
        }else if(value==3){
            this.setState({
                element1:false,
                element2:false,
                element3:true,
                element4:false,
            });
        }else if(value==4){
            this.setState({
                element1:false,
                element2:false,
                element3:false,
                element4:true,
            });
        }

        this.setState({ [key]: value });
      }

      editPractice(){
        var studentid=this.state.student;
        var startdate="";
        var enddate="";

        this.props.student_all_practiceschedule(studentid, startdate, enddate).then((data) => {              
            var resdata=data.data;
             if(resdata.length==1){
                 for (let w = 1; w <=2; w++) {
                     for (let j = 1; j <=7; j++) {
                         
                         for (let i = 1; i <=5; i++) {
 
                             var shotlabel="practshot_"+w+"_"+j+"_"+i;
                             var typelabel="practtype_"+w+"_"+j+"_"+i;
                             var drilllabel="practdrill_"+w+"_"+j+"_"+i;
                             var eddrllabel="edpractdrill_"+w+"_"+j+"_"+i;
                             var lsttyplabel="typeopt_"+w+"_"+j+"_"+i;
                             var lstdrllabel="drillopt_"+w+"_"+j+"_"+i;
 
                             if (resdata[0].hasOwnProperty('practshot_'+w+'_'+j+'_'+i)) {                           
                                     
                                 this.setState({ 
                                     [shotlabel]: resdata[0][shotlabel],
                                     [typelabel]: resdata[0][typelabel],
                                     [drilllabel]: resdata[0][drilllabel],
                                     [eddrllabel]: resdata[0][eddrllabel],
                                     [lsttyplabel]: resdata[0][lsttyplabel],
                                     [lstdrllabel]: resdata[0][lstdrllabel]
                                 }); 
                             }else{
                                 this.setState({ 
                                     [shotlabel]: '',
                                     [typelabel]: '',
                                     [drilllabel]: '',
                                     [eddrllabel]: '',
                                     [lsttyplabel]: [],
                                     [lstdrllabel]: []
                                 });  
                             }
                             
                                 
                         }
                     }
                 }
 
               
             }else{
                 
                 for (let w = 1; w <=2; w++) {
                     for (let j = 1; j <=7; j++) {
                         
                         for (let i = 1; i <=5; i++) {
 
                             var shotlabel="practshot_"+w+"_"+j+"_"+i;
                             var typelabel="practtype_"+w+"_"+j+"_"+i;
                             var drilllabel="practdrill_"+w+"_"+j+"_"+i;
                             var eddrllabel="edpractdrill_"+w+"_"+j+"_"+i;
                             var lsttyplabel="typeopt_"+w+"_"+j+"_"+i;
                             var lstdrllabel="drillopt_"+w+"_"+j+"_"+i;
 
                             this.setState({ 
                                 [shotlabel]: '',
                                 [typelabel]: '',
                                 [drilllabel]: '',
                                 [eddrllabel]: '',
                                 [lsttyplabel]: [],
                                 [lstdrllabel]: []
                             });  
                             
                                 
                         }
                     }
                 }
 
  
 
                 for (let j = 1; j <=7; j++) {
                     
                     for (let i = 1; i <=5; i++) {
                         var shotlabel="practshot_1_"+j+"_"+i;
                         var typelabel="practtype_1_"+j+"_"+i;
                         var drilllabel="practdrill_1_"+j+"_"+i;
                         var eddrllabel="edpractdrill_1_"+j+"_"+i;
                         var lsttyplabel="typeopt_1_"+j+"_"+i;
                         var lstdrllabel="drillopt_1_"+j+"_"+i;
                             
                         this.setState({ 
                             [shotlabel]: '',
                             [typelabel]: '',
                             [drilllabel]: '',
                             [eddrllabel]: '',
                             [lsttyplabel]: [],
                             [lstdrllabel]: []
                         });  
                         
                             
                     }
                 }
                
             }
             this.setState({
                 viewdiv2:false,
                 viewdiv3:false,
                 editdiv2:true,
                 editdiv3:true,
             });  
             
            
         });
      }
    
    render() {
        const { match, studentlists, loading } = this.props;   
        const stdrole = localStorage.getItem('stdrole');    
        const allstudent=studentlists.map((stdval) => {  
            return {
               label: stdval.student,  
               value: stdval.uudID
            }
        });

       return (
          <div>
             

                
                <div className="row" style={{marginBottom:"20px"}}>
                    <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                    <div className="col-lg-8"><h2 className="text-center">PRACTICE SCHEDULE</h2></div>
                    <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.props.onClick1(1)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                </div>          

               
                {this.state.viewdiv2 &&    
                <div className="row"> 
                       
                        <div className="weekseldiv">
                            <BottomNavigation value={this.state.example1} onChange={(e, value) => this.handleChange('example1', value)} showLabels>
                                <BottomNavigationAction label="Week 1" value="1" />
                                <BottomNavigationAction label="Week 2" value="2" />
                                <BottomNavigationAction label="Week 3" value="3" />
                                <BottomNavigationAction label="Week 4" value="4" />
                            </BottomNavigation>
                        </div>                       
                </div>
                }
                {this.state.viewdiv3 &&  
                    <>         
                    <div className="slider">
                        <div key={0}>
                            {this.state.element1 && 
                                <ShowPSElement1 onClick={this.onBackSection} data={this.state}/>
                            }
                        </div>  
                        <div key={1}> 
                            {this.state.element2 && 
                                <ShowPSElement2 onClick={this.onBackSection} data={this.state}/>
                            }
                        </div>
                        <div key={2}> 
                            {this.state.element3 && 
                                <ShowPSElement3 onClick={this.onBackSection} data={this.state}/>
                            }
                        </div>
                        <div key={3}> 
                            {this.state.element4 && 
                                <ShowPSElement4 onClick={this.onBackSection} data={this.state}/>
                            }
                        </div>
                    </div>
                     {stdrole==0? <div className="ddd"><button class="mr-3 mb-3 btn btn-outline-primary" onClick={this.editPractice}>Edit Practice Schedule</button></div> : ''}
                     </>
                }
                
                {this.state.editdiv2 &&    
                    <div className="row"> 
                            <div className="weekseldiv">
                                <BottomNavigation value={this.state.example1} onChange={(e, value) => this.handleChange('example1', value)} showLabels>
                                    <BottomNavigationAction label="Week 1" value="1" />
                                    <BottomNavigationAction label="Week 2" value="2" />
                                    <BottomNavigationAction label="Week 3" value="3" />
                                    <BottomNavigationAction label="Week 4" value="4" />
                                </BottomNavigation>
                            </div>                       
                    </div>
                }
                {this.state.editdiv3 &&           
                    <div className="slider">
                        <div key={0}>
                            {this.state.element1 && 
                                <EditPSElement1 onClick={this.onBackSection} data={this.state}/>
                            }
                        </div>  
                        <div key={1}> 
                            {this.state.element2 && 
                                <EditPSElement2 onClick={this.onBackSection} data={this.state}/>
                            }
                        </div>
                        <div key={2}> 
                            {this.state.element3 && 
                                <EditPSElement3 onClick={this.onBackSection} data={this.state}/>
                            }
                        </div>
                        <div key={3}> 
                            {this.state.element4 && 
                                <EditPSElement4 onClick={this.onBackSection} data={this.state}/>
                            }
                        </div>
                    </div>
                }
               
            
          </div>
       )
    }
 }
 
 const mapStateToProps = ({ mostlyused  }) => {
    const { studentlists, loading } = mostlyused;
	return { studentlists, loading };
}

export default connect(mapStateToProps, {
    allStudents,
    student_all_practiceschedule
})(practiceschedule); 